/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Delete_Dialog_DescInputs */

const en_ui_delete_dialog_desc = /** @type {(inputs: Ui_Delete_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will permanently delete everything: all training sessions, personal bests, lap data, time-series records, your connected integrations, and your profile (thresholds, preferences). This action cannot be undone.`)
};

const de_ui_delete_dialog_desc = /** @type {(inputs: Ui_Delete_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das löscht dauerhaft alles: Trainingseinheiten, persönliche Bestleistungen, Rundendaten, Zeitreihen, deine verbundenen Integrationen und dein Profil (Schwellenwerte, Einstellungen). Diese Aktion lässt sich nicht rückgängig machen.`)
};

/**
* | output |
* | --- |
* | "This will permanently delete everything: all training sessions, personal bests, lap data, time-series records, your connected integrations, and your profile ..." |
*
* @param {Ui_Delete_Dialog_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_delete_dialog_desc = /** @type {((inputs?: Ui_Delete_Dialog_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Delete_Dialog_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_delete_dialog_desc(inputs)
	return de_ui_delete_dialog_desc(inputs)
});